import { useTranslation } from "react-i18next";

import { useDateTime } from "../../../../../../../../shared";
import VehicleDataTypesList from "../../../../../../../Schedules/components/VehicleDataTypesList/VehicleDataTypesList";
import useScheduleRepeatValues from "../../../../../../../Schedules/hooks/useScheduleRepeatValues/useScheduleRepeatValues";
import { DriverScheduleDto, ScheduleDto } from "../../../../../../types";

import ScheduleDetailsSingleRow from "./ScheduleDetailsSingleRow";

interface ScheduleDetailsContentProps {
  schedule: ScheduleDto;
  isDriversPage?: boolean;
}

const ScheduleDetailsContent = ({
  schedule,
  isDriversPage = false
}: ScheduleDetailsContentProps) => {
  const { t } = useTranslation();
  const { convertToCurrentDateFormat, formattedDate } = useDateTime();
  const { getRepeatString } = useScheduleRepeatValues();

  const {
    customRepeat,
    fileTypes,
    period,
    repeat,
    scheduleStartTime,
    nextDueDate,
    quick,
    activitiesNextStartDate,
    activitiesNextEndDate
  } = schedule as ScheduleDto & DriverScheduleDto;

  const repeatValue = isDriversPage ? period : repeat;

  const commonRows = [
    {
      title: t("Dialog##name"),
      content: schedule?.name
    },
    {
      title: t("Schedules##start date"),
      content: formattedDate(scheduleStartTime)
    }
  ];

  const quickScheduleRows = [
    //create additional prop to not set to timezone
    {
      title: t("Schedules##activities from"),
      content: convertToCurrentDateFormat(activitiesNextStartDate)
    },
    {
      title: t("Schedules##activities to"),
      content: convertToCurrentDateFormat(activitiesNextEndDate)
    }
  ];

  const recurringScheduleRows = [
    {
      title: t("Schedules##next due date"),
      content: formattedDate(nextDueDate)
    },
    {
      title: t("Schedules##repeat"),
      content: getRepeatString(repeatValue, customRepeat)
    }
  ];

  const showQuickRowsOnVehicles = quick && !isDriversPage;
  const shouldShowDataTypes = Boolean(fileTypes);

  const dataTypesRow = {
    title: t("Schedules##data types"),
    dataTypes: <VehicleDataTypesList schedule={schedule} size="medium" />
  };

  return (
    <>
      {commonRows.map(row => (
        <ScheduleDetailsSingleRow
          key={row.title}
          title={row.title}
          content={row.content}
        />
      ))}

      {showQuickRowsOnVehicles &&
        quickScheduleRows.map(row => (
          <ScheduleDetailsSingleRow
            key={row.title}
            title={row.title}
            content={row.content}
          />
        ))}

      {!quick &&
        recurringScheduleRows.map(row => (
          <ScheduleDetailsSingleRow
            key={row.title}
            title={row.title}
            content={row.content}
          />
        ))}

      {shouldShowDataTypes && (
        <ScheduleDetailsSingleRow
          title={dataTypesRow.title}
          dataTypes={dataTypesRow.dataTypes}
        />
      )}
    </>
  );
};

export default ScheduleDetailsContent;
